<div [formGroup]="formGroup" class="no-field-space">

  <sc-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.attach-detach.dialog.step.title.detach-trailer-semi-trailer-truck"></sc-dictionary-label>
  </sc-title>

  <sc-content-spacer vertical></sc-content-spacer>

  <mat-radio-group formControlName="transportScope">
    <div>
      <mat-radio-button class="option" [value]="TransportScope.TRAILER">
        <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.transport-scope.{{TransportScope.TRAILER}}"></sc-dictionary-label>
      </mat-radio-button>
    </div>
    <div>
      <mat-radio-button class="option" [value]="TransportScope.SWAP_TRAILER">
        <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.transport-scope.{{TransportScope.SWAP_TRAILER}}"></sc-dictionary-label>
      </mat-radio-button>
    </div>
  </mat-radio-group>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-flex>
    <sc-string-field formControlName="cargo" grow labelDictionaryKey="tmc-yard.entity.transport.cargo"></sc-string-field>
    <sc-content-spacer></sc-content-spacer>
    <sc-string-field formControlName="orderReference" grow labelDictionaryKey="tmc-yard.entity.transport.reference"></sc-string-field>
  </sc-flex>

  <sc-content-spacer vertical></sc-content-spacer>

  @if (this.stepperModel.workingData.targetTransportScope === TransportScope.TRAILER) {
    <sc-flex>
      <sc-string-field formControlName="trailerNumberPlate" grow labelDictionaryKey="tmc-yard.entity.transport.masterdata.firstLoadCarrier.trailerNumberPlate"></sc-string-field>
      <sc-content-spacer></sc-content-spacer>
      <sc-string-field formControlName="trailerIdentifier" grow labelDictionaryKey="tmc-yard.ui.transport.attach-detach.dialog.label.trailerIdentifier"></sc-string-field>
    </sc-flex>
  }

  @if (this.stepperModel.workingData.targetTransportScope === TransportScope.SWAP_TRAILER) {
    <sc-flex>
      <sc-string-field formControlName="swapTrailerNumber" grow labelDictionaryKey="tmc-yard.entity.transport.masterdata.firstLoadCarrier.swapTrailerNumber"></sc-string-field>
    </sc-flex>
  }

  <sc-content-spacer vertical></sc-content-spacer>
  <app-structure-selection-field (selectionChanged)="onStationSelectionChanged($event)"></app-structure-selection-field>

</div>
